import React, { useMemo } from 'react';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { aIChatPlaygroundContext, aIChatPlaygroundErrorModalId } from '../../aIChatPlaygroundConstants';
import { SlConfirmationModal } from '../../../../shared/public/SlConfirmationModal/SlConfirmationModal';
import { Container, i18n } from '../../../../symphony';
import { ErrorStatusCodes } from '../../aIChatPlaygroundInterface';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';

export const AIChatPlaygroundErrorModal = () => {
  const { errorStatusCode } = useContainerData(
    aIChatPlaygroundContext.value,
    AIChatPlaygroundStore,
    ['errorStatusCode'],
  );
  const { errorCtaCloseHandler } = Container.take(
    aIChatPlaygroundContext.value,
    AIChatPlaygroundService,
  );
  const { titleKey, descriptionKey, ctaKey } = useMemo(() => {
    if (!errorStatusCode || errorStatusCode === ErrorStatusCodes.ChatGptError) return {};

    let titleKey = 'ai-chat.error.generic.title';
    let descriptionKey = 'ai-chat.error.generic.description';
    let ctaKey = '';

    switch (errorStatusCode) {
      case ErrorStatusCodes.InternalServerError:
        break;
      case ErrorStatusCodes.PromptTooLong:
        titleKey = 'ai-chat.error.long-prompt.title';
        descriptionKey = 'ai-chat.error.long-prompt.description';
        ctaKey = 'ai-chat.error.long-prompt.cta';
        break;
      case ErrorStatusCodes.LimitReached:
        titleKey = 'ai-chat.error.limit.title';
        descriptionKey = 'ai-chat.error.limit.description';
        ctaKey = 'ai-chat.error.limit.cta';
        break;
      case ErrorStatusCodes.InappropriateContent:
        titleKey = 'ai-chat.error.inappropriate-content.title';
        descriptionKey = 'ai-chat.error.inappropriate-content.description';
        ctaKey = 'ai-chat.error.inappropriate-content.cta';
        break;
      default:
        break;
    }

    return { titleKey, descriptionKey, ctaKey };
  }, [errorStatusCode]);

  return (
    <SlConfirmationModal
      title={i18n.t(titleKey)}
      info={i18n.t(descriptionKey)}
      actions={ctaKey ? [{
        name: i18n.t(ctaKey),
        btnType: 'primary',
        handler: errorCtaCloseHandler,
      }] : []}
      closeBtnCallback={errorCtaCloseHandler}
      modalId={aIChatPlaygroundErrorModalId}
    />
  );
};
